import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

import categoriesScaffolding from './categoriesScaffolding/reducer';
import addresses from './addresses/reducer';
import auth from './auth/reducer';
import cart from './cart/reducer';
import ui from './ui/reducer';

const root = combineReducers({
    categoriesScaffolding,
    addresses,
    auth,
    cart,
    ui,
    toastr: toastrReducer
});

export default root;



// WEBPACK FOOTER //
// ./src/ducks/index.js